import type { DocumentNode } from 'graphql'
import { GraphQLFormattedError, print } from 'graphql'
import { sha256 } from '@shared/api/gql-service/sha-256-helper'
import sha from '@shared/api/gql-service/sha-256-x'

/**
 * @see https://github.com/graphql/graphql-spec/blob/main/spec/Section%207%20--%20Response.md#response-format
 */
export type GQLResult<T> = { data: T; errors?: undefined } | { data?: undefined; errors: GraphQLFormattedError[] }

export class LightGQLServiceHelper {
  static getOperationMetainfo = async (operation: DocumentNode) => {
    const operationString = print(operation)
    const hash = await sha(operationString) // https://graph.afisha.ru/graphql
    const name = this._extractOperationName(operation)

    return { string: operationString, name, hash }
  }

  private static _extractOperationName(document: DocumentNode): string | null {
    const operation = document.definitions.find((def) => def.kind === 'OperationDefinition' && def.name)
    //@ts-ignore
    return operation?.name?.value || null
  }

  static extensions = (extensions: { persistedQueryHash?: string }) => ({
    persistedQuery: extensions.persistedQueryHash
      ? {
          version: 1,
          sha256Hash: extensions.persistedQueryHash,
        }
      : undefined,
  })

  static async getRequest<T>(endpoint: string, payload: object, init?: RequestInit) {
    const query = new URLSearchParams()

    Object.entries(payload).forEach(([key, value]) => {
      query.append(key, typeof value === 'object' ? JSON.stringify(value) : String(value))
    })

    const reqHeaders = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
      ...init?.headers,
    }

    // console.log('!!! getRequest reqHeaders', reqHeaders)
    const response = await fetch(`${endpoint}?${query}`, {
      method: 'GET',
      headers: reqHeaders,
      ...init,
    })

    return response.json() as Promise<GQLResult<T>>
  }

  static async postRequest<T>(endpoint: string, payload: object, init?: RequestInit) {
    const initHeaders = init?.headers || {}

    const reqHeaders = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
      ...initHeaders,
    }
    // console.log('!!! postRequest reqHeaders', reqHeaders)

    const response = await fetch(endpoint, {
      method: 'POST',
      body: JSON.stringify(payload),
      ...init,
      headers: reqHeaders,
    })

    return response.json() as Promise<GQLResult<T>>
  }
}
